import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Icon, ICONS } from "./Icon";

interface BackHeaderProps {
  title?: string;
  onBack: () => void;
  /** O'ng tomon sloti (mas. status badge "Shoshilinch"). */
  right?: ReactNode;
  /** Rasm ustida turganda — yarim shaffof orqa fon. */
  floating?: boolean;
}

/**
 * Sahifa header bari — Figma §6.2. "‹ Orqaga" chap, markazda title, o'ngda slot.
 */
export function BackHeader({ title, onBack, right, floating = false }: BackHeaderProps) {
  const { t } = useTranslation();
  return (
    <header
      className="relative flex h-14 items-center justify-between px-4"
      style={floating ? undefined : { background: "var(--c-surface)" }}
    >
      <button
        type="button"
        onClick={onBack}
        aria-label={t("back")}
        className="inline-flex items-center gap-1 rounded-xl py-1.5 pl-1.5 pr-3 text-sm font-medium transition-transform active:scale-95"
        style={
          floating
            ? { background: "color-mix(in srgb, var(--c-surface) 70%, transparent)", color: "var(--c-text)", backdropFilter: "blur(8px)" }
            : { background: "var(--c-elevated-2)", color: "var(--c-text)" }
        }
      >
        <Icon name={ICONS.back} size={18} />
        {t("back")}
      </button>

      {title && (
        <h1
          className="pointer-events-none absolute left-1/2 -translate-x-1/2 text-base font-semibold"
          style={{ color: "var(--c-text)" }}
        >
          {title}
        </h1>
      )}

      <div className="flex items-center">{right}</div>
    </header>
  );
}
